import { gql } from '@src/lib/gql'

export const EXTRACT_ADVISOR_APPLICATION_FROM_BIO = gql`
  mutation ExtractAdvisorApplicationFromBio($input: ExtractAdvisorApplicationFromBioInput!) {
    extractAdvisorApplicationFromBio(input: $input) {
      headline
      categories
      skills
      userExperiences {
        id
        userExperienceId
        organizationName
        experienceTypeKey
        positionTitle
        positionDescription
      }
      user {
        id
        userId
        firstName
        lastName
        email
        pictureUrl
        location
        title
        shortBio
        bio
      }
    }
  }
`
